import type { TonoPastilla } from '@/shared/ui/Pastilla/Pastilla'

/**
 * El rol en la aplicación dicho como se dice en MEGA.
 *
 * No es el cargo de la nómina: Juan Diego Loaiza tiene cargo «Proyectos» y en
 * la aplicación es gerente operativo —aprueba compras, da horas, programa—.
 * Johan preguntó por qué no se veían los roles actualizados: la pantalla solo
 * enseñaba el cargo.
 */
export const ROL_EN_LA_APP: Record<string, { etiqueta: string; tono: TonoPastilla }> = {
  gerencia: { etiqueta: 'Gerencia', tono: 'marca' },
  gerente_operativo: { etiqueta: 'Gerente operativo', tono: 'compuerta' },
  operario: { etiqueta: 'Técnico', tono: 'neutro' },
  administrador: { etiqueta: 'Administrador', tono: 'cerrado' },
  bodega: { etiqueta: 'Bodega', tono: 'neutro' },
  cartera: { etiqueta: 'Cartera', tono: 'neutro' },
}
